import { get, post } from '../../../../services/request';

// Get Facility Custom View Fields
export const getFacilityCustomViewFieldsAPI = (viewId) => {
    return get(`SiteManagement/GetFacilityCustomViewFieldsByViewID?ViewID=${viewId}`);
};

// Save Facility Custom View
export const saveFacilityCustomViewAPI = (payload) => {
    return post('SiteManagement/SaveFacilityCustomView', payload);
};

export const getAllFacilityCustomViewsByUserId = () =>
  get("SiteManagement/GetAllFacilityCustomViewsByUserID");

export const toggleFacilityCustomView = (payload) =>
  post("SiteManagement/ActivateDeactivateFacilityCustomView", payload);

export const deleteFacilityCustomView = (payload) =>
  post("SiteManagement/DeleteFacilityCustomView", payload);

export const getFacilityCustomViewData = (customViewId) =>
  get(`SiteManagement/GetFacilityCustomViewDataByID?CustomViewID=${customViewId}`);

export const fetchSiteCustomViewShareDropdownAPI = (payload) =>
  post('SiteManagement/GetFacilityCustomViewSharedList', payload);

export const saveSharedSiteCustomViewAPI = (payload) =>
  post('SiteManagement/ShareFacilityCustomView', payload);